export default __webpack_public_path__ + "static/media/aidsMapHispanic.9e0315e6.png";